// @ts-nocheck
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import Input from 'antd/lib/input';
import { RangePicker } from '../../../components/ui';
import { Filter, FilterButtonsContainer, FilterContainer, FilterItem, Selects } from './../../../components';
import Field from './../../../components/card/Field';
import { formatDateTimeToISOString } from './../../../lib/helpers';
const {
  SideServiceTypeSelect
} = Selects;
const SpoilerContent = styled.div.withConfig({
  displayName: "Filter__SpoilerContent",
  componentId: "sc-10mwb7c-0"
})(["padding:16px;"]);
export const SideServiceTariffFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) => <SpoilerContent>
    <FilterContainer>
      <Filter cleanFilter={cleanFilter} applyFilter={applyFilter} initialValues={filter}>
        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) => <>
            <FilterItem>
              <Field mBottomNone>
                <SideServiceTypeSelect size="small" onChange={value => changeValue('sideServiceType', value)} value={values.sideServiceType} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker size="small" startDate={values.startDate ? moment.utc(values.startDate) : null} endDate={values.endDate ? moment.utc(values.endDate) : null} onChange={changeValue} />
              </Field>
            </FilterItem>

            <FilterButtonsContainer applyFilter={applyFilter} cleanFilter={cleanFilter} />
          </>}
      </Filter>
    </FilterContainer>
  </SpoilerContent>;
export default SideServiceTariffFilter;
